import { algoliaClient } from '../api/algolia/algolia.client';
import { algoliaClickHit } from '../algolia-react/events/algolia.clickHit';
import { algoliaViewHit } from '../algolia-react/events/algolia.viewHit';
import { dlItemsViewListEvent } from '../events/dl.Items.viewList.event';
import { getImgSizesString } from '../utils/getImgSizesString';
import { dlDispatchAmplEvent } from '../events/dl.dispatchAmplEvent';
const doc = document;
const vn = window.vNode;
const algIndex = 'pc_related_product';
const CLIENT = algoliaClient('K2CTT24UP3', '2ddbb0a8db153957543d851ca677c689');
const INDEX = CLIENT.initIndex(algIndex);
const RECOMM = CLIENT.initRecommendations({ maxRecommendations: 11 });
let queryID = '';
const search = async (filters) => {
    return await INDEX.search('', {
        analytics: true,
        clickAnalytics: true,
        hitsPerPage: 11,
        page: 0,
        filters,
        responseFields: ['hits'],
        attributesToRetrieve: [
            'artist_name',
            'main_image',
            'objectID',
            'reviews_avg_rating',
            'reviews_count',
            'shopify_id',
            'sku',
            'title',
            'url',
            'wish_count',
            'layouts'
        ]
    });
};
const fillItemsList = (hits, container, customFilter) => {
    const vNodes = hits.map((hit, i) => {
        return vn.create('product-card-new-component', {
            data: {
                'slider-item': ''
            },
            key: hit.objectID,
            class: 'd:block',
            _hit: hit,
            _filters: {
                shapes: [],
                pieces: [],
                types: [],
                rooms: [],
                names: []
            },
            _use3Dimg: false,
            _imageSizes: getImgSizesString({ sm: 'calc(41.667vw - 0.7292rem)', md: 'calc(25vw - 0.4375rem)', xl: 'calc(18.9404vw - 0.35rem)', xxl: '17.75rem' }),
            _clickCallback: () => {
                window.dataLayer.push({
                    recently_click_item: null,
                    related_click_item: {
                        sku: hit.sku,
                        shopify_id: hit.shopify_id,
                        title: hit.title,
                        position: i,
                        collection_name: 'Related Products'
                    },
                    event: 'related_products_click'
                });
                algoliaClickHit({
                    index: algIndex,
                    queryID,
                    hit,
                    position: i + 1,
                    ...(customFilter !== undefined
                        ? {
                            collectionName: 'Related Products by custom filter',
                            collectionType: 'custom'
                        }
                        : {
                            collectionName: 'Algolia recommendations',
                            collectionType: 'recommendations'
                        })
                });
                dlDispatchAmplEvent('Related artworks', { target: hit.title });
            }
        });
    });
    container.innerHTML = '';
    vn.patch([], vNodes, container);
};
const getItems = async (customFilter) => {
    if (customFilter !== undefined) {
        const response = await search(customFilter);
        queryID = response.queryID;
        dlItemsViewListEvent([{
                name: 'Related Products by custom filter',
                filter: customFilter,
                type: 'custom'
            }]);
        return response.hits;
    }
    if (window.ppData.sku !== undefined) {
        const response = await RECOMM.get([window.ppData.sku]);
        if (response !== null && response[0].hits.length > 9) {
            queryID = 'RECOMM';
            dlItemsViewListEvent([{
                    name: 'Algolia recommendations',
                    type: 'recommendations'
                }]);
            return response[0].hits;
        }
    }
    return null;
};
void (async function () {
    if (window.navigator.userAgent.includes('bot')) {
        document.querySelector('.product__related_section')?.remove();
        return;
    }
    const section = doc.querySelector('.product__related_section');
    if (section === null)
        return;
    const itemsWrapper = section.querySelector('[data-slider]');
    if (itemsWrapper === null)
        return;
    let hits = await getItems(itemsWrapper.dataset.customFilter);
    if (hits === null || hits.length < 11) {
        section.remove();
        return;
    }
    hits = hits.filter((hit) => {
        return hit.shopify_id !== window.ppData.id;
    });
    if (hits.length > 10)
        hits.length = 10;
    fillItemsList(hits, itemsWrapper, itemsWrapper.dataset.customFilter);
    const relatedItems = [];
    for (const hit of hits) {
        const index = hits.indexOf(hit);
        relatedItems.push({
            sku: hit.sku,
            shopify_id: hit.shopify_id,
            title: hit.title,
            position: index,
            collection_name: 'Related Products'
        });
    }
    algoliaViewHit(algIndex, queryID, hits, 1);
    window.dataLayer.push({
        recently_items: null
    });
    window.dataLayer.push({
        event: 'related_products_shown',
        related_items: relatedItems
    });
    section.querySelector('slider-component')?.update();
}());
